import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, change, Field } from 'redux-form';

import { Login, loginValidation } from '../../actions/authActions';

import { Button, createTheme, Grid, TextField, ThemeProvider } from '@material-ui/core';

import logo from '../../assets/images/SentricsLogoPng.png'


const validate = (values) => {
    const errors = {};

    if (!values.user) {
        errors.user = 'Please type the user';

    }

    if (!values.password) {
        errors.password = 'Please type the password';

    }

    return errors;
};

const theme = createTheme({
    palette: {
        primary: {
            main: '#000000'
        },
    }

});

const renderTextField = ({
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
}) => (
    <ThemeProvider theme={theme}>
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
        />
    </ThemeProvider>


)

class TVMessagingLogin extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: '',
            password: '',
            apiError: '',
            isDisabled: true
        };

        this.props.dispatch(change('TVMessagingLogin', 'user', ''));
        this.props.dispatch(change('TVMessagingLogin', 'password', ''));
    }

    CheckBtnDisabled = () => {
        const updState = {
            isDisabled: this.state.isDisabled
        }

        if (this.state.user !== '' && this.state.password !== '') {
            updState.isDisabled = false;
        } else {
            updState.isDisabled = true
        }

        this.setState(updState);

    }

    componentDidMount = async () => {

        if (localStorage.getItem("token") != null) {
            await this.props.loginValidation();
            this.props.history.push("/legacyTVMessaging");
        }
    }


    handleChange = (target) => {
        this.setState({
            ...this.state,
            [target.name]: target.value
        }, () => this.CheckBtnDisabled())
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ apiError: '' })
        const response = await this.props.Login(this.state.user, this.state.password);

        if (!response.success) {
            this.setState({ apiError: response.error })
            return;
        }

        this.props.history.push("/legacyTVMessaging");
    }

    render() {
        return (
            <>
                <Grid item container xs={12} justifyContent='center' className='login_screen' alignItems='center' style={{ height: window.innerHeight }}>

                    <Grid item container xs={12} justifyContent='center'>
                        <Grid item container xs={12} justifyContent='center'>
                            <img
                                src={logo}
                                width='300px'
                                alt='sentrics_logo'
                            />
                        </Grid>

                        <Grid item container  xs={10} md={5} lg={4} className='login_container' justifyContent='center' >
                            <Grid item container alignItems='center' justifyContent='center'  style={{paddingBottom:'60px'}} >
                                <svg fill='#105A88' width='30px' height='30px' viewBox="0 0 512 512">
                                    <path xmlns="http://www.w3.org/2000/svg" d="M256 32C114.6 32 .0272 125.1 .0272 240c0 49.63 21.35 94.98 56.97 130.7c-12.5 50.37-54.27 95.27-54.77 95.77c-2.25 2.25-2.875 5.734-1.5 8.734C1.979 478.2 4.75 480 8 480c66.25 0 115.1-31.76 140.6-51.39C181.2 440.9 217.6 448 256 448c141.4 0 255.1-93.13 255.1-208S397.4 32 256 32z"/>
                                </svg>
                                <span className='login_subtitle'> TV Messaging </span>
                            </Grid>
                            <form onSubmit={(e) => this.handleSubmit(e)}>
                                <Grid item container xs={12} justifyContent='center' >
                                    <ThemeProvider theme={theme}>

                                        <Field
                                            label='User'
                                            name='user'
                                            fullWidth
                                            style={{ marginBottom: '20px' }}
                                            component={renderTextField}
                                            InputLabelProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            InputProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            onChange={({ target }) => this.handleChange(target)}
                                            value={this.state.user}

                                        />

                                        <Field
                                            label='Password'
                                            name='password'
                                            fullWidth
                                            type='password'
                                            component={renderTextField}
                                            InputLabelProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            InputProps={{
                                                style: { fontFamily: 'Gotham-Book', fontSize: '20px' }
                                            }}
                                            onChange={({ target }) => this.handleChange(target)}
                                            value={this.state.password}

                                        />

                                        {
                                            this.state.apiError &&
                                            <Grid item xs={12} className='errorText'>{this.state.apiError}</Grid>
                                        }
                                    </ThemeProvider>

                                    <Grid item xs={6} lg={3} style={{paddingTop:'60px'}}>
                                        <Button
                                            className={this.state.isDisabled ? 'login_btn login_btn_disabled' : 'login_btn'}
                                            type='submit'
                                            disabled={this.state.isDisabled}>
                                            Sign In
                                        </Button>
                                    </Grid>

                                </Grid>
                            </form>
                        </Grid>

                        <Grid item container xs={12} justifyContent='center'>
                            <Grid item container xs={10} md={5} lg={4} justifyContent='flex-end'>
                                <Grid item  className='forgot_password'>
                                    Forgot Password?
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }
}


function mapStateToProps(state) {

    return {

    }
};

export default connect(mapStateToProps, { Login, loginValidation })
    (reduxForm({
        form: 'TVMessagingLogin',
        validate,
        enableReinitialize: true,
    })(TVMessagingLogin));
